import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { buildFunnelPath, extractUtmParams, submitFunnelOptin } from '../../lib/funnelPublicApi';

const inputClass =
  'w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#00AAFF] focus:border-transparent';

export default function OptinForm({
  funnelId,
  stepId,
  funnelSlug,
  entryPoint = 1,
}) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const setField = (key) => (e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!form.first_name.trim() || !form.last_name.trim() || !form.email.trim() || !form.phone.trim()) {
      setError('All fields are required.');
      return;
    }

    setLoading(true);
    try {
      const utm = extractUtmParams(searchParams);
      const result = await submitFunnelOptin({
        funnel_id: funnelId,
        step_id: stepId,
        first_name: form.first_name.trim(),
        last_name: form.last_name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        entry_point: entryPoint,
        ...utm,
      });

      if (result.next_step_url) {
        const stepSlug = result.next_step_url.replace(/^\//, '');
        navigate(buildFunnelPath(funnelSlug, stepSlug, searchParams));
      }
    } catch (err) {
      setError(err.message || 'Submission failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-8 px-4 sm:px-0">
      <div className="max-w-lg mx-auto bg-white border border-gray-200 rounded-xl p-6 sm:p-8 shadow-sm">
        <h2 className="text-xl font-bold text-gray-900 text-center mb-6">
          Get Instant Access
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label htmlFor="optin-first-name" className="block text-sm font-medium text-gray-700 mb-1">
                First Name
              </label>
              <input
                id="optin-first-name"
                type="text"
                required
                value={form.first_name}
                onChange={setField('first_name')}
                className={inputClass}
                autoComplete="given-name"
              />
            </div>
            <div>
              <label htmlFor="optin-last-name" className="block text-sm font-medium text-gray-700 mb-1">
                Last Name
              </label>
              <input
                id="optin-last-name"
                type="text"
                required
                value={form.last_name}
                onChange={setField('last_name')}
                className={inputClass}
                autoComplete="family-name"
              />
            </div>
          </div>
          <div>
            <label htmlFor="optin-email" className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              id="optin-email"
              type="email"
              required
              value={form.email}
              onChange={setField('email')}
              className={inputClass}
              autoComplete="email"
            />
          </div>
          <div>
            <label htmlFor="optin-phone" className="block text-sm font-medium text-gray-700 mb-1">
              Phone
            </label>
            <input
              id="optin-phone"
              type="tel"
              required
              value={form.phone}
              onChange={setField('phone')}
              className={inputClass}
              autoComplete="tel"
            />
          </div>

          {error && (
            <p className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-4 py-3">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 rounded-lg text-white font-semibold text-base transition-opacity hover:opacity-90 disabled:opacity-60"
            style={{ backgroundColor: '#00AAFF' }}
          >
            {loading ? 'Submitting…' : 'Continue'}
          </button>
        </form>
      </div>
    </section>
  );
}
